import { put } from 'redux-saga/effects';

import { mergeMessages } from "state/teachers/actions";

export default function* fetchMessages(action) {
    
  yield put( mergeMessages() );
  
}



// WEBPACK FOOTER //
// ./src/state/teachers/sagas/mergeMessages.js